import styled from 'styled-components'

const FooterSeparator = styled.div`
  width: calc(100% - 40px);
  max-width: calc(1024px - 80px);
  height: 1px;
  border: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    width: calc(100% - 80px);
  }
`

export const TopTenantSeparator = styled(FooterSeparator)`
  background-color: ${({theme}) => theme.shell.footer.tenants.topSeparatorColor};
  display: ${({theme}) => (theme.shell.footer.tenants.topSeparatorColor ? 'block' : 'none')};
`

export const TopCopyrightSeparator = styled(FooterSeparator)`
  background-color: ${({theme}) => theme.shell.footer.copyright.topSeparatorColor};
  display: ${({theme}) => (theme.shell.footer.copyright.topSeparatorColor ? 'block' : 'none')};
`
